import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';
import { applyTicket } from '@/utils/security';

const baseUrl = envConfig.formalServer + "/cotton/"

const baseApi = () => {
  function queryUserDetailInfo() {
      return Post(baseUrl + "web/queryUserDetailInfo", null)
  }

  function sendCaptchaByAccount(data) {
      return Post(baseUrl + "sendCaptchaByAccount", data)
  }

  function checkPhoneCaptcha(data) {
      return Post(baseUrl + "checkPhoneCaptcha", data)
  }

  function updateOrAddPhone(data) {
      return Post(baseUrl + "updateOrAddPhone", data)
  }

  function sendCaptchaByPhone(data) {
      let header = {};
      return applyTicket(header, 'sms', data.phone).then(result => {
          return Post(baseUrl + 'sendCaptchaByPhone', data, { headers: header });
      });
  }

  function updatePassword(data) {
      return Post(baseUrl + "updatePassword", data)
  }

  function updatePasswordByPhone(data) {
      return Post(baseUrl + "updatePwdByPhone", data)
  }

    function queryAccountInfoByAccountOrPhone(data) {
        return Post(baseUrl + 'web/queryAccountInfoByAccountOrPhone', data);
  }

  function judgePhoneCaptchaByAccountOrPhone(data) {
      return Post( baseUrl+ "web/judgePhoneCaptchaByAccountOrPhone", data)
  }

  function updateUserInfo(data) {
      return Post(baseUrl + "web/updateUserInfo", data)
  }

    function deletePlayer() {
      return Post(baseUrl + "deletePlayer", {})
  }

  return {
      queryUserDetailInfo,
      sendCaptchaByAccount,
      checkPhoneCaptcha,
      updateOrAddPhone,
      sendCaptchaByPhone,
      updatePassword,
      updatePasswordByPhone,
      queryAccountInfoByAccountOrPhone,
      judgePhoneCaptchaByAccountOrPhone,
      updateUserInfo,
      deletePlayer
  }
}

export const accountApi = baseApi()
